














import { defineComponent, toRefs, PropType, computed } from '@vue/composition-api';
import Vue from 'vue';
import { useNotify } from '@tt4b/ttam-utils';
import { useVideoExtStatus, useCreativeToolTask } from '@tt4b/ttam-hooks';
import {
  AdgroupFormData,
  CampaignFormData,
  FullNormalFormData,
  TaskStatus,
  MaterialType,
  VideoTaskItem,
} from '@tt4b/ttam-enums';
import CreativeToolInOne from './index';

const name = 'ttam-creative-tool-in-one-compose';
export default defineComponent({
  name,
  components: {
    TtamCreativeToolInOne: CreativeToolInOne.TtamCreativeToolInOne,
  },
  props: {
    isNative: { type: Boolean, default: false },
    marginTop: { type: String },
    creativeUuid: { type: String, default: '' },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { isNative, adgroupData, campaignData, creativeData, creativeUuid } = toRefs(props);

    const { $on } = useNotify();
    const { setExtVideoProcessByTaskId, batchSetExtVideoStatus } = useVideoExtStatus();
    const { transformTaskToMaterial } = useCreativeToolTask();

    const url = CreativeToolInOne.useCreativeToolInOneUrl();
    const { lang } = CreativeToolInOne.usePropsCreativeToolInOneLang();
    const { visible, open: openTool, close: closeTool } = CreativeToolInOne.usePropsCreativeToolInOneVisible();
    const { initDataMethod } = CreativeToolInOne.usePropsCreativeToolInOneInitMethod({
      creativeUuid,
      campaignData,
      adgroupData,
      creativeData,
    });

    function open() {
      openTool();
      // 注册工具的回调函数
      $on(creativeUuid.value, (message: { data: VideoTaskItem[]; status: TaskStatus }) => {
        if (message.status === TaskStatus.start) {
          emit('start', message);
        }
        if (message.status === TaskStatus.process) {
          setExtVideoProcessByTaskId(message.data);
        }
        if (message.status === TaskStatus.error && message.data?.length) {
          batchSetExtVideoStatus(message.data);
        }
        if (message.status === TaskStatus.success) {
          const { task_id } = message.data[0] ?? {};
          transformTaskToMaterial({
            list: message.data ?? [],
            type: MaterialType.Video,
            isNative: isNative.value,
            isGetExtVideoInfo: false,
          }).then(materialArr => {
            const param = materialArr.map(item => ({ material: item, taskId: task_id }));
            emit('task-success', param);
          });
        }
      });
    }

    function close() {
      closeTool();
      emit('close');
    }

    function onSuccess(data) {
      emit('success', data);
      close();
    }

    const _marginTop = computed(() => props.marginTop ?? `${Vue.prototype.$TTAMUI?.headerHeight}px`);

    return {
      name,
      url,
      lang,
      visible,
      initDataMethod,
      open,
      close,
      onSuccess,
      _marginTop,
    };
  },
});
